<template>
    <div>
        <b-row>
            <b-col cols="12" class="text-end">
                <b-button @click="addType">{{ $translate('add_process') }}</b-button>
            </b-col>
        </b-row>
        <b-modal v-model="itemModal" id="item-modal" header-class="p-0"
            footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap form-sample"
            @ok="saveTemplateType">
            <template #modal-title="{ cancel }">
                <div class="title-block text-center p-2">{{ `${(model.id ? $translate('edit') : $translate('add'))}
                                    ${$translate('type')}` }}</div>
                <div class="close-btn" @click="cancel()">x</div>
            </template>
            <b-form bg-variant="light">
                <b-col cols="12">
                    <label for="input-sequence_no" class="mb-3"><strong>{{ $translate('sequence_no') }}</strong></label>
                    <b-form-input type="number" id="input-sequence_no" v-model="model.sequence_no" required
                        placeholder="Sequence Number" inputmode="numeric" trim></b-form-input>
                </b-col>
                <b-col cols="12" class="mt-3 dd">
                    <label for="input-checkoff_type_id" class="mb-3"><strong>{{ $translate('review_type')
                    }}</strong></label>
                    <b-form-select id="input-checkoff_type_id" class="form-control" v-model="model.checkoff_type_id"
                        :options="types" text-field="name" value-field="id" required trim>
                        <template #first>
                            <b-form-select-option :value="null" disabled>{{ $translate('select_the_review_type')
                            }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-form>
            <template #modal-footer="{ ok, cancel }">
                <b-button variant="info" size="fw" @click="ok()">
                    {{
                        `${!!model.index || !!model.id
                            ? $translate('create')
                            : $translate('update')
                            } ${$translate('type')}`
                    }}
                </b-button>
                <b-button size="fw" v-if="!!model.id || !!model.index" variant="delete-button"
                    @click="deleteTemplateType()">
                    {{ $deleteLabel() }}
                </b-button>
                <b-button size="fw" variant="info" @click="cancel()">
                    {{ $cancelLabel() }}
                </b-button>
            </template>
        </b-modal>

        <b-table responsive :items="templateTypes" :fields="itemFields">
            <template #cell(id)="{ value }">
                <b-button variant="pink-button" @click="viewType(value)" class="mr-2">
                    <img src="@/assets/images/icon/view.svg">
                </b-button>
            </template>
        </b-table>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    props: ['template'],
    mixins: [popupMixins],
    data() {
        return {
            itemFields: [
                {
                    key: 'id',
                    label: 'Actions',
                },

                {
                    key: 'sequence_no',
                    label: 'Sequence',
                },
                /*   {
                    key: 'previous_sequence_no',
                    label: 'Prev',
                }, */

                {
                    key: 'checkoff_type_id',
                    label: 'Type',
                    formatter: (value, key, item) => item.checkoff_type.name,
                },
            ],
            model: {
                id: null,
                checkoff_type_id: null,
                sequence_no: null,
                previous_sequence_no: null,
            },
            loading: false,
            itemModal: false,
            modelChanged: false,
        }
    },

    computed: {
        componentName() { return this.$translate('review_template') },
        submitLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else if (this.loading) {
                return this.$translate('creating')
            } else if (this.model.id) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },

        types() {
            const items = this.$store.state.checkoffTypes.types
            console.log('items', items)
            return items
        },
        templateTypes() {
            const _templateTypes = (this.template && this.template.types) || []
            _templateTypes.sort((a, b) => a.sequence_no - b.sequence_no)
            return _templateTypes
        },
    },
    watch: {},

    methods: {
        addType() {
            this.model = {
                id: null,
                previous_sequence_no: null,
                sequence_no: null,
                checkoff_type_id: null,
            }
            this.itemModal = true
        },
        async viewType(id) {
            /* if the template exists find the item among the template's 
            types otherwise, firnd the item among the template model's types */
            const templateType =
                this.template.types.find(x => x.id === id) || {}
            this.model = { ...templateType }
            this.itemModal = true
        },
        async deleteTemplateType() {
            // if the template exists delete the master item from the database

            const path = `checkoffTemplates/deleteType`
            const template_id = this.template.id
            const item_id = this.model.id

            try {
                this.loading = true
                await this.$store.dispatch(path, { template_id, item_id })
                this.itemModal = false
                this.modelChanged = false
            } catch (error) {
                console.log('error', error)
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.loading = false
            }
        },

        async saveTemplateType(bvModalEvt) {
            bvModalEvt.preventDefault()

            const item = { ...this.model }

            console.log('model item', item)

            item.previous_sequence_no = item.previous_sequence_no || 0
            const template_id = this.template.id
            const model = { template_id, item }

            // if the template exists add the master item to the template in the database or update it in the database
            const path = `checkoffTemplates/${parseInt(item.id) ? 'updateType' : 'createType'
                }`
            try {
                this.loading = true
                await this.$store.dispatch(path, model).then(() => {
                    `${parseInt(item.id) ?
                        this.doToast(this.$translate('updated'), `${this.componentName} ${this.$translate('update_alert')}`, 'Success') :
                        this.doToast(this.$translate('created'), `${this.componentName} ${this.$translate('create_alert')}`, 'Success')}`
                })
                this.loading = false
                this.itemModal = false
                this.modelChanged = false
            } catch (error) {
                console.log('error', error)
                let message = error.message
                this.doToast(this.$translate('error'), message, 'danger')
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
